export const selectChargingPoints = (state) => state.chargingPoints?.list;
export const selectIsButtonLoadingForId = (state, cpId, connectorId) => {
  if (!state?.chargingPoints?.list?.length) {
    return false;
  }

  const connector = state.chargingPoints.list
    .find(cp => cp.id === cpId)
    ?.chargePointConnectors
    ?.find(conn => conn.id === connectorId);

  return connector?.isButtonLoading ?? false;
};
